import React from 'react';

import 'react-phone-number-input/style.css'
import { isValidPhoneNumber } from 'react-phone-number-input';
import PhoneInput from 'react-phone-number-input';

import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';

import Radio from '@material-ui/core/Radio';
import FormLabel from '@material-ui/core/FormLabel';

import '../Components.css';
import './Payment.css';


class PaymentForm extends React.Component {

    getLocationDropdown = () => {

        return (
            <div className="location-selection">
                <Grid item xs={12} sm={6}>
                    <Select
                        id="location"
                        select
                        label="Location"
                        fullWidth
                        name="location"
                        className="locations-dropdown"
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            },
                            getContentAnchorEl: null
                        }}
                    value={this.props.storeLocation}
                    onChange={e => this.handleChange('location', e.target.value)}
                    >
                        {this.props.shippingLocations.map((option, index) => (
                            <MenuItem key={index} value={option.location_id}>
                                {option.location_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </div>
        )
    }

    processText = (type, value) => {
        this.handleChange(type, value);
    }

    handleChange = (field, value) => {
        let paymentValids = this.props.valids.payment;
        switch (field) {
            case "firstName":
                if (value !== undefined && value !== null && value !== "" && value.trim().length !== 0) {
                    paymentValids.firstName = true;
                } else if (value === "") {
                    paymentValids.firstName = false
                }
                this.props.setFirstName(value);
                break;

            case "lastName":
                if (value !== undefined && value !== null && value !== "" && value.trim().length !== 0) {
                    paymentValids.lastName = true;
                } else if (value === "") {
                    paymentValids.lastName = false
                }
                this.props.setLastName(value);
                break;

            case "email":
                //check regex
                var Regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
                if (value) {
                    if (Regex.test(value)) {
                        paymentValids.email = true;
                    } else {
                        paymentValids.email = false;
                    }
                }
                 else if (value === "") {
                    paymentValids.email = false;
                }
                this.props.setEmail(value);
                break;

            case "phone":
                if (value) {
                    if (isValidPhoneNumber(value)) {
                        paymentValids.phone = true;
                    } else {
                        paymentValids.phone = false;
                    }
                } else {
                    paymentValids.phone = false;
                }
                this.props.setPhone(value);
                break;

            case "deliveryOption":
                this.props.setDeliveryOption(value);
                if (value === 'outsideStore') {
                    //reset location
                    this.props.setStoreLocation(1);
                }
                break;
            
            case "location":
                this.props.setStoreLocation(value)
                break;
            
            default:
                return;
        }

        //update valids
        let newValids = this.props.valids;
        newValids.payment = paymentValids;
        this.props.updateValids(newValids);
    }

    render() {

        let locationComponent = (this.props.deliveryOption === "inStore") ? this.getLocationDropdown() : null;

        return (
            <React.Fragment>
                <Typography variant="h6" gutterBottom>
                    <div className="section-header">Purchase Details</div>
                </Typography>
                <Grid container spacing={24}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="first_name"
                            name="first_name"
                            label="First Name"
                            fullWidth
                            value={this.props.firstName}
                            // defaultValue={this.props.firstName}
                            onChange={e => {
                                this.processText("firstName", e.target.value);
                            }}
                            error={(this.props.valids.payment.firstName === null || !this.props.valids.payment.firstName) && this.props.nextAttempted}
                            helperText={((this.props.valids.payment.firstName === null || !this.props.valids.payment.firstName) && this.props.nextAttempted) ? "Please enter a name" : ""}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="last_name"
                            name="last_name"
                            label="Last Name"
                            fullWidth
                            value={this.props.lastName}
                            // defaultValue={this.props.lastName}
                            onChange={e => {
                                this.processText("lastName", e.target.value);
                            }}
                            error={(this.props.valids.payment.lastName === null || !this.props.valids.payment.lastName) && this.props.nextAttempted}
                            helperText={((this.props.valids.payment.lastName === null || !this.props.valids.payment.lastName) && this.props.nextAttempted) ? "Please enter a name" : ""}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="email"
                            name="email"
                            label="Email Address"
                            fullWidth
                            value={this.props.email}
                            // defaultValue={this.props.email}
                            onChange={e => {
                                this.processText("email", e.target.value);
                            }}
                            error={(this.props.valids.payment.email === null || !this.props.valids.payment.email) && this.props.nextAttempted}
                            helperText={((this.props.valids.payment.email === null || !this.props.valids.payment.email) && this.props.nextAttempted) ? "Please enter a email" : ""}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} className={(!this.props.valids.payment.phone && this.props.nextAttempted)? "red-background" : ''}>
                        <PhoneInput
                            placeholder={"(519)-123-4567"}
                            value={this.props.phone}
                            // defaultValue={this.props.phone}
                            // onChange={this.handleChange}
                            country={"CA"}
                            autoComplete="new-password"
                            className="phone-input"
                            onChange={phone => this.handleChange("phone", phone)}
                        />

                    </Grid>
                </Grid>
                {/* radio button group */}
                <div className="receiving-container">
                    <div className="section-sub-header">Select Your Receiving Option</div>
                    <div className="radio-buttons-container">
                        <div className="radio-button">
                            <FormLabel component="legend">Pickup In-Store</FormLabel>
                            <Radio
                                checked={this.props.deliveryOption === 'inStore'}
                                onChange={e => this.handleChange('deliveryOption', e.target.value) }
                                value="inStore"
                                name="receiving-options"
                                className="radioBtn"
                            />
                        </div>
                        <div className="radio-button">
                            <FormLabel component="legend">Ship to Me</FormLabel>
                            <Radio
                                checked={this.props.deliveryOption === 'outsideStore'}
                                onChange={e => this.handleChange('deliveryOption', e.target.value) }
                                value="outsideStore"
                                name="receiving-options"
                                className="radioBtn"
                            />
                        </div>
                    </div>
                    {locationComponent}
                </div>

            </React.Fragment>
        )
    }
}

PaymentForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles()(PaymentForm);